
































































import Vue from 'vue';
import { authService, googleAuthService } from '@/services';
import { TypeGuards } from '@/utilities/TypeGuards';
import { RouteName } from '@/router/RouteName';
import { LinkedAccountType } from '@/models';

export default Vue.extend({
  name: 'Login',

  data: () => ({
    username: null as string | null,
    usernameRules: [(username: string) => !!username || 'Username is required'],
    password: null as string | null,
    passwordRules: [(password: string) => !!password || 'Password is required'],
    formValid: false,
    errorMessage: null as string | null,
    showErrorAlert: false,
    loading: false
  }),

  methods: {
    async googleLogin(): Promise<void> {
      this.loading = true;
      this.clearErrorMessage();

      try {
        const googleUser = await googleAuthService.signIn();
        const idToken = googleUser.getAuthResponse().id_token;
        await authService.loginGoogle(idToken);
        this.errorMessage = null;
        this.$router.push({ name: RouteName.WatchLists });
      } catch (error) {
        if (TypeGuards.isAxiosError(error) && error.response?.status === 404) {
          this.$router.push({ name: RouteName.Register, query: { socialLogin: LinkedAccountType.Google } });
        } else {
          this.showErrorMessage('Unable to login with Google.');
        }
      } finally {
        this.loading = false;
      }
    },

    async login(): Promise<void> {
      this.clearErrorMessage();

      if (!this.username || !this.password) {
        this.showErrorMessage('Username and password are required.');
        return;
      }

      try {
        this.loading = true;
        await authService.login(this.username, this.password);
        this.errorMessage = null;
        this.$router.push({ name: RouteName.WatchLists });
      } catch (error) {
        if (TypeGuards.isAxiosError(error) && error.response?.status === 401) {
          this.showErrorMessage('Invalid username or password.');
        } else {
          this.showErrorMessage('Unable to login.');
        }
      } finally {
        this.loading = false;
      }
    },

    showErrorMessage(message: string): void {
      this.errorMessage = message;
      this.showErrorAlert = true;
    },

    clearErrorMessage(): void {
      this.errorMessage = null;
      this.showErrorAlert = false;
    },

    resetForm(): void {
      this.errorMessage = null;
      (this.$refs.form as any).reset();
    }
  }
});
